import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.751 10.667V4.478l1.802 1.8a.75.75 0 0 0 1.06-1.06L8.575 2.183a.748.748 0 0 0-1.126-.024l-3.063 3.06a.75.75 0 0 0 1.06 1.06l1.805-1.803v6.19a.75.75 0 1 0 1.5 0m-6.834 0v1.166a2.25 2.25 0 0 0 2.25 2.25h7.666a2.25 2.25 0 0 0 2.25-2.25v-1.167a.75.75 0 0 0-1.5 0v1.167a.75.75 0 0 1-.75.75H4.167a.75.75 0 0 1-.75-.75v-1.167a.75.75 0 0 0-1.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }